/**
 * Normalizes latitude and longitude to valid ranges:
 * - Latitude: [-90, 90]
 * - Longitude: [-180, 180]
 *
 * This is needed because when zoomed out, Leaflet shows multiple world copies,
 * and clicking on them can produce coordinates outside the standard range.
 */
export function normalizeCoordinates(coords: { lat: number; lon: number }): {
  lat: number;
  lon: number;
} {
  let { lat, lon } = coords;

  // Normalize longitude to [-180, 180]
  // Using modulo to wrap around
  lon = ((((lon + 180) % 360) + 360) % 360) - 180;

  // Clamp latitude to [-90, 90]
  // Latitude doesn't wrap, it needs to be clamped
  lat = Math.max(-90, Math.min(90, lat));

  return { lat, lon };
}
